/**
 * Created by r4zi4l on 03.08.2021
 */

// update config from here: https://docs.google.com/spreadsheets/d/1V--Y1ZfuxNuNk-LWxsWaSEN7E64n66g7c84q8r6GYrU/edit?gid=686562638#gid=686562638

const AdsLimits = function () {
    cleverapps.EventEmitter.call(this);

    this.limits = this.parseConfig();

    this.usage = {};
    this.load();

    this.update();

    cleverapps.rewardedAdsManager.onRewardedRefresh(this.notifyUpdated.bind(this));
    cleverapps.rewardedAdsManager.onInterstitialRefresh(this.notifyUpdated.bind(this));

    new cleverapps.Interval(this.update.bind(this), cleverapps.parseInterval("1 minute"));

    if (connector.platform.oneOf(connector.INSTANT)) {
        cleverapps.country.on("update", this.update.bind(this));
    }
};

AdsLimits.prototype = Object.create(cleverapps.EventEmitter.prototype);
AdsLimits.prototype.constructor = AdsLimits;

AdsLimits.prototype.getInfo = function () {
    return this.usage;
};

AdsLimits.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.ADS_LIMITS_DATA, this.getInfo());
};

AdsLimits.prototype.load = function () {
    this.usage = cleverapps.dataLoader.load(DataLoader.TYPES.ADS_LIMITS_DATA) || {};
};

AdsLimits.prototype.parseConfig = function () {
    const config = cleverapps.config.adslimits;
    if (config === undefined) {
        if (cleverapps.config.debugMode) {
            throw new Error("No ads limits config");
        }

        return {};
    }

    for (const type in config) {
        if (type === "adTiers" || type === "remote") {
            continue;
        }

        const limit = config[type];

        for (const adTier of config.adTiers) {
            limit[adTier].available = limit.available;
        }
    }

    return config;
};

AdsLimits.prototype._nonPayerSegment = function () {
    const tiers = Object.keys(AdsLimits.THRESHOLDS);

    for (const adTier of tiers.slice(0, -1)) {
        const segmentThreshold = AdsLimits.THRESHOLDS[adTier];
        const threshold = segmentThreshold[cleverapps.config.type] || segmentThreshold.default || segmentThreshold;

        const isInSegment = !cleverapps.user.checkAvailable(threshold);
        if (isInSegment) {
            return adTier;
        }
    }

    return tiers[tiers.length - 1];
};

AdsLimits.prototype._getTier = function () {
    const status = cleverapps.paymentsHistory.classify();
    const nonPayerSegment = this._nonPayerSegment();
    const isAdPlatform = connector.platform.oneOf(connector.GDCOM, connector.WECHAT, connector.YANDEX, connector.YOUTUBE, connector.ADDICTINGGAMES);
    // const isIAPPlatform = connector.platform.oneOf(connector.INSTANT, connector.CRAZY);
    const isVKOK = connector.platform.oneOf(connector.VK, connector.OK, connector.OKBRIDGE, connector.MM);
    const regularMonetization = cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR;
    const countryTier = cleverapps.country.getCountryTier();
    const isDesktop = !connector.info.isMobile;

    let tier = undefined;

    if (cleverapps.vipAdsAdapter.isVIP() || status !== cleverapps.PaymentsHistory.BRACKET_NONE) {
        tier = "payer";
    } else if (connector.platform.oneOf(connector.CRAZY) && isDesktop && countryTier === "T1" || connector.platform.oneOf(connector.INSTANT) && isDesktop) {
        tier = "undecided";
    } else if ((!regularMonetization || isAdPlatform || ["T3", "T4"].includes(countryTier) && !isVKOK) && nonPayerSegment === "undecided") {
        tier = Object.keys(AdsLimits.THRESHOLDS).find((adTier) => adTier !== "undecided");
    } else {
        tier = nonPayerSegment;
    }

    if (connector.platform.oneOf(connector.CRAZY) && cleverapps.config.crazy && cleverapps.config.crazy.launch) {
        const tiers = Object.keys(AdsLimits.THRESHOLDS);
        tier = tiers[tiers.length - 1];
    }

    if (!this.limits.adTiers.includes(tier)) {
        tier = "nonpayer";
    }

    return tier;
};

AdsLimits.prototype._getLimit = function (type) {
    const limit = this.limits[type];

    if (limit === undefined) {
        if (cleverapps.config.debugMode) {
            throw new Error(`No ads limit for type: ${type}`);
        }

        return {
            disabled: true
        };
    }

    const tier = this._getTier();

    return limit[tier];
};

AdsLimits.prototype._updateType = function (type) {
    const limit = this._getLimit(type);
    const usage = this.usage[type];

    if (usage) {
        if (limit.disabled || limit.limit === "unlimited" || usage && usage.watchCount > 0 && this._getLimitLeftTime(limit, type) === 0) {
            delete this.usage[type];

            this.save();
            return true;
        }
    }

    return false;
};

AdsLimits.prototype.getLimitLeftTime = function (type) {
    const limit = this._getLimit(type);
    return this._getLimitLeftTime(limit, type);
};

AdsLimits.prototype._getLimitLeftTime = function (limit, type) {
    const usage = this.usage[type] || {
        lastRefresh: 0
    };

    return Math.max(0, usage.lastRefresh + this._getLimitTimeout(limit, type) - Date.now());
};

AdsLimits.prototype.getLimitTimeout = function (type) {
    const limit = this._getLimit(type);

    return this._getLimitTimeout(limit, type);
};

AdsLimits.prototype._getLimitTimeout = function (limit) {
    if (limit && limit.timeout) {
        return cleverapps.parseInterval(limit.timeout);
    }
    return 0;
};

AdsLimits.prototype.notifyUpdated = function () {
    this.trigger("update");
};

AdsLimits.prototype.update = function () {
    let dirty = false;
    Object.keys(this.limits).forEach((type) => {
        if (this._updateType(type)) {
            dirty = true;
        }
    });
    if (dirty) {
        this.notifyUpdated();
    }
};

AdsLimits.prototype.state = function (type) {
    const isInterstitial = AdsLimits.INTERSTITIAL_TYPES.includes(type);
    const isSticky = (type === AdsLimits.TYPES.BANNER);

    let isSupported;

    if (isSticky) {
        isSupported = connector.ads.isStickySupported;
    } else if (isInterstitial) {
        isSupported = connector.ads.isInterstitialSupported;
    } else {
        isSupported = connector.ads.isRewardedSupported;
    }

    if (!isSupported) {
        return AdsLimits.STATE_DISABLED;
    }

    this._updateType(type);
    const limit = this._getLimit(type);
    if (limit === undefined) {
        if (cleverapps.config.debugMode) {
            throw new Error(`No ads limit for type: ${type}`);
        }
    }

    if (limit !== undefined && limit.disabled) {
        return AdsLimits.STATE_DISABLED;
    }

    const watchCount = this.getWatchCount(type);
    const watchLimit = this.getWatchLimit(type);

    if (watchLimit !== "unlimited" && watchCount >= watchLimit) {
        return AdsLimits.STATE_LIMITED;
    }

    const available = cleverapps.user.checkAvailable(limit.available);
    if (!available) {
        return AdsLimits.STATE_UNAVAILABLE;
    }

    let adAvailable;

    if (isSticky) {
        adAvailable = connector.ads.isStickyAvailable;
    } else if (isInterstitial) {
        adAvailable = connector.ads.isInterstitialAvailable;
    } else {
        adAvailable = connector.ads.isRewardedAvailable;
    }

    if (!adAvailable && !cleverapps.vipAdsAdapter.isVIP()) {
        return AdsLimits.STATE_NOT_LOADED;
    }

    if (isInterstitial && this.deadNetworkUntil > Date.now()) {
        return AdsLimits.STATE_NOT_LOADED;
    }

    return AdsLimits.STATE_READY;
};

AdsLimits.prototype.getLimit = function (type) {
    return this._getLimit(type);
};

AdsLimits.prototype.getWatchCount = function (type) {
    return this.usage[type] && this.usage[type].watchCount || 0;
};

AdsLimits.prototype.getWatchLimit = function (type) {
    const limit = this._getLimit(type);

    return limit.limit;
};

AdsLimits.prototype.watch = function (type) {
    if (this.usage[type]) {
        this.usage[type].watchCount++;
    } else {
        this.usage[type] = {
            watchCount: 1,
            lastRefresh: cleverapps.getCooldownStartTime(this.getLimitTimeout(type))
        };
    }

    if ([AdsLimits.TYPES.INTERSTITIAL, AdsLimits.TYPES.BANNER].indexOf(type) === -1) {
        this.delayInterstitial();
    }

    this.save();

    this.notifyUpdated();
};

AdsLimits.prototype.delayInterstitial = function () {
    const interTimeout = this.getLimitTimeout(AdsLimits.TYPES.INTERSTITIAL);
    const minLeftTime = Math.min(cleverapps.parseInterval(AdsLimits.MIN_INTERSTITIAL_DELAY), interTimeout / 2);

    AdsLimits.INTERSTITIAL_TYPES.forEach((type) => {
        if (this.getLimitLeftTime(type) >= minLeftTime) {
            return;
        }

        const usage = this.usage[type] || {
            watchCount: this.getWatchLimit(type)
        };

        usage.lastRefresh = Date.now() + minLeftTime - this.getLimitTimeout(type);

        this.usage[type] = usage;
    });
};

// a failed interstitial must not burn the limit - on low-fill networks most attempts fail - but the next attempt waits
// out the breather so a dead network is not hammered; not a limit, so it reads as "not loaded" and logs no ad_limit_skip
AdsLimits.prototype.noHammerDeadNetwork = function () {
    this.deadNetworkUntil = Date.now() + cleverapps.parseInterval(AdsLimits.DEAD_NETWORK_DELAY);
};

AdsLimits.prototype.reset = function (type) {
    delete this.usage[type];
    this.save();
};

AdsLimits.STATE_UNAVAILABLE = 0;
AdsLimits.STATE_LIMITED = 1;
AdsLimits.STATE_NOT_LOADED = 2;
AdsLimits.STATE_READY = 3;
AdsLimits.STATE_DISABLED = 4;

AdsLimits.TYPES = {
    HARD: "hard",
    LIVES: "lives",
    ENERGY_SHORT: "energy_short",
    TOOLBAR: "toolbar",
    POINTS_THIRD_ELEMENT: "third_element_points",
    FREEX2: "freex2",
    PRODUCT: "product",
    PROLONGATION: "extend",
    BOOSTER_1: "booster_1",
    BOOSTER_2: "booster_2",
    BOOSTER_3: "booster_3",
    SCORE_BAR: "score_bar",

    BANNER: "banner",
    PREROLL: "preroll",

    INTERSTITIAL: "interstitial",
    INTERSTITIAL_OTHER: "inter_other",
    INTERSTITIAL_PLAY: "inter_play",
    INTERSTITIAL_INACTIVE: "inter_inactive"
};

AdsLimits.THRESHOLDS = {
    undecided: {
        default: { actualLevel: 20 }
    },

    nonpayer20: {
        default: { actualLevel: 40 }
    },

    nonpayer40: {
        default: { actualLevel: 80 }
    },

    nonpayer80: {}
};

AdsLimits.MIN_INTERSTITIAL_DELAY = "1 minute";
AdsLimits.DEAD_NETWORK_DELAY = "30 seconds";

AdsLimits.INTERSTITIAL_TYPES = [
    AdsLimits.TYPES.PREROLL,
    AdsLimits.TYPES.INTERSTITIAL
];